export class PaymentOnHandingOver {
    public isAllowed?: boolean;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): PaymentOnHandingOver {
        const paymentOnHandingOver: PaymentOnHandingOver = new PaymentOnHandingOver();

        paymentOnHandingOver.isAllowed = this.isAllowed;

        return paymentOnHandingOver;
    }
}
